var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "el-form",
                {
                  ref: "pageFrom",
                  attrs: {
                    inline: "",
                    size: "small",
                    model: _vm.pageFrom,
                    "label-position": "right",
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单编号：" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: {
                          placeholder: "请输入订单编号",
                          size: "small",
                          clearable: "",
                        },
                        model: {
                          value: _vm.pageFrom.orderNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.pageFrom, "orderNo", $$v)
                          },
                          expression: "pageFrom.orderNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品名称：" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: {
                          placeholder: "请输入商品名称",
                          size: "small",
                          clearable: "",
                        },
                        model: {
                          value: _vm.pageFrom.productName,
                          callback: function ($$v) {
                            _vm.$set(_vm.pageFrom, "productName", $$v)
                          },
                          expression: "pageFrom.productName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单状态：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: { clearable: "", placeholder: "全部" },
                          model: {
                            value: _vm.pageFrom.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.pageFrom, "status", $$v)
                            },
                            expression: "pageFrom.status",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "全部", value: "" },
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.orderStatusOptions, function (item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value },
                            })
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "店铺类型：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: { clearable: "", placeholder: "请选择" },
                          model: {
                            value: _vm.pageFrom.storeType,
                            callback: function ($$v) {
                              _vm.$set(_vm.pageFrom, "storeType", $$v)
                            },
                            expression: "pageFrom.storeType",
                          },
                        },
                        _vm._l(_vm.storeTypeOptions, function (item) {
                          return _c("el-option", {
                            key: item.key,
                            attrs: { label: item.value, value: item.key },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "支付时间：" } },
                    [
                      _c("el-date-picker", {
                        staticClass: "selWidth",
                        attrs: {
                          type: "datetimerange",
                          "range-separator": "至",
                          "start-placeholder": "开始时间",
                          "end-placeholder": "结束时间",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          size: "small",
                        },
                        model: {
                          value: _vm.payTimeRange,
                          callback: function ($$v) {
                            _vm.payTimeRange = $$v
                          },
                          expression: "payTimeRange",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.search },
                        },
                        [_vm._v("查询")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            size: "small",
                            loading: _vm.exportLoading,
                          },
                          on: { click: _vm.exportOrders },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.exportLoading ? "导出中..." : "订单导出"
                              ) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: { click: _vm.resetSearch },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.tableData.list,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "orderNo",
                  label: "订单编号",
                  "min-width": "190",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "productName",
                  label: "商品名称",
                  "min-width": "180",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "merchantName",
                  label: "所属商户",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "storeName",
                  label: "所属门店",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "storeTypeName",
                  label: "店铺类型",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "reservationName",
                  label: "预订人",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "reservationPhone",
                  label: "预订手机号",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderAmount",
                  label: "订单金额(¥)",
                  "min-width": "120",
                  align: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.formatAmount(scope.row.totalPrice)) +
                            "\n          "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "platformCollection",
                  label: "平台收款",
                  "min-width": "200",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.formatPlatformCollection(scope.row)) +
                            "\n          "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "statusName",
                  label: "订单状态",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getStatusType(scope.row.status),
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  scope.row.statusName ||
                                    _vm.getStatusName(scope.row.status)
                                ) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "dataSource",
                  label: "数据来源",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建时间",
                  "min-width": "160",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "payTime",
                  label: "支付时间",
                  "min-width": "160",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "150",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openOrderDetail(scope.row.orderNo)
                              },
                            },
                          },
                          [_vm._v("详情")]
                        ),
                        _vm._v(" "),
                        scope.row.status === 1
                          ? _c(
                              "el-button",
                              {
                                attrs: { size: "small", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleCancelOrder(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n              取消订单\n            ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        [2, 3, 41, 10].includes(scope.row.status)
                          ? _c(
                              "el-button",
                              {
                                attrs: { size: "small", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleRefund(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n              退款\n            ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status === 2
                          ? _c(
                              "el-button",
                              {
                                attrs: { size: "small", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.changeToUsed(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n              状态变更\n            ")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.tableData.total > 0
            ? _c("el-pagination", {
                attrs: {
                  "current-page": _vm.pageFrom.page,
                  "page-sizes": _vm.constants.page.limit,
                  layout: _vm.constants.page.layout,
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("OrderDetail", { ref: "orderDetailRef" }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "酒店订单退款确认",
            visible: _vm.refundDialogVisible,
            width: "460px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.refundDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.refundPreviewLoading,
                  expression: "refundPreviewLoading",
                },
              ],
              staticClass: "refund-preview",
            },
            [
              _vm.refundPreview
                ? [
                    _c("p", [
                      _vm._v(
                        "退款比例：" +
                          _vm._s(_vm.refundPreview.refundRate) +
                          "%"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "退款总金额：¥" +
                          _vm._s(
                            _vm.formatAmount(_vm.refundPreview.refundAmount)
                          )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "现金退款：¥" +
                          _vm._s(
                            _vm.formatAmount(_vm.refundPreview.cashRefundAmount)
                          )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "福豆退款：" +
                          _vm._s(
                            _vm.formatAmount(
                              _vm.refundPreview.fudouRefundAmount
                            )
                          )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "优惠券：" +
                          _vm._s(
                            _vm.refundPreview.couponRefund
                              ? "全额退款后返还"
                              : "部分退款不返还"
                          )
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.refundPreview.oneCardRightReturnCount > 0
                      ? _c("p", [
                          _vm._v(
                            "\n            一卡通权益：退款成功后返还 " +
                              _vm._s(
                                _vm.refundPreview.oneCardRightReturnCount
                              ) +
                              " 次\n          "
                          ),
                        ])
                      : _vm._e(),
                  ]
                : _vm.refundPreviewError
                ? _c("el-alert", {
                    attrs: {
                      title: _vm.refundPreviewError,
                      type: "warning",
                      closable: false,
                      "show-icon": "",
                    },
                  })
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.refundDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "warning", loading: _vm.refundSubmitting },
                  on: {
                    click: function ($event) {
                      return _vm.submitHotelRefund(1)
                    },
                  },
                },
                [_vm._v("按退款规则退款")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "danger", loading: _vm.refundSubmitting },
                  on: {
                    click: function ($event) {
                      return _vm.submitHotelRefund(2)
                    },
                  },
                },
                [_vm._v("全额退款")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }